import React,{useEffect} from 'react'
import useAxios from 'axios-hooks'
import { useProjects } from 'context/project-context'
import { getAuthHeader } from 'utils/auth'
import { ErrorBoundary, FullPageSpinner } from 'components'
import NewScanForm from 'views/ScanSettings/NewScan/components/NewScanForm'

const NewScan = ({ navigate }) => {
	const { project } = useProjects()

	const [{ data: restrictions, loading: loadingRestrictions, error: restrictionsError }] = useAxios({
		url: '/global/restrictions',
		method: 'GET',
		headers: getAuthHeader()
	})

	const [{ data: cookies, loading: loadingCookies, error: cookiesError }] = useAxios({
		url: '/global/cookies',
		method: 'GET',
		headers: getAuthHeader()
	})

	const [{ data: labels, loading: loadingLabels, error: labelsError }] = useAxios({
		url: '/global/labels',
		method: 'GET',
		headers: getAuthHeader()
	})

	const [{ data: flows, loading: loadingFlows, error: flowsError }] = useAxios({
		url: '/global/flows',
		method: 'GET',
		headers: getAuthHeader()
	})

	const [{ data: webhooks, loading: loadingWebhooks, error: webhooksError }] = useAxios({
		url: '/global/webhooks',
		method: 'GET',
		headers: getAuthHeader()
	})

	const [{ data: filters, loading: loadingFilters, error: filtersError }] = useAxios({
		url: '/global/filters',
		method: 'GET',
		headers: getAuthHeader()
	})

	const [{ data: rules, loading: loadingRules, error: rulesError }] = useAxios({
		url: '/global/rules',
		method: 'GET',
		headers: getAuthHeader()
	})

	const [{ data: newScanData, loading: newScanLoading, error: newScanError }, executeNewScanSettings] = useAxios(
		{
			url: `/${project.name}/scan-settings`,
			method: 'POST',
			headers: getAuthHeader()
		},
		{ manual: true }
	)

	const loadingDone =
		!loadingRestrictions && !loadingCookies && !loadingLabels && !loadingFlows && !loadingWebhooks && !loadingFilters

	const error =
		restrictionsError || cookiesError || labelsError || flowsError || webhooksError || filtersError


	//if (!newScanError && newScanLoading) return <FullPageSpinner />
	if (!newScanError && newScanData && newScanData.id) navigate(`../`)

	return loadingDone ? (
		<ErrorBoundary>
			<NewScanForm
				project={project}
				restrictions={restrictions}
				loadingRestrictions={loadingRestrictions}
				cookies={cookies}
				loadingCookies={loadingCookies}
				labels={labels}
				loadingLabels={loadingLabels}
				flows={flows}
				loadingFlows={loadingFlows}
				webhooks={webhooks}
				loadingWebhooks={loadingWebhooks}
				filters={filters}
				loadingFilters={loadingFilters}
				rules={rules}
				loadingRules={loadingRules}
				error={error && error.response}
				executeNewScanSettings={executeNewScanSettings}
				newScanError={newScanError && newScanError.response}
			/>
		</ErrorBoundary>
	) : (
		<FullPageSpinner />
	)
}

export default NewScan
